// CLASSES
import AppConfig from "@classes/AppConfig";

export default function(props, state)
{
    if (AppConfig.get("developmentOptions").ignoreFullfillment === true)
    {
        return true;
    }

    const {fields} = state;

    if (fields.accounts.options.length === 0)
    {
        if (fields.customer_account_number.length <= 0 || fields.customer_placement_name.length <= 0)
        {
            return false;
        }
    }
    else
    {
        let accountSelected = false;
        let accountOtherSelected = false;
        for (let i = 0; i < fields.accounts.options.length; i++)
        {
            if (fields.accounts.options[i].checked)
            {
                accountSelected = true;
                if (fields.accounts.options[i].value === "-")
                {
                    accountOtherSelected = true;
                }
            }
        }

        if (!accountSelected)
        {
            return false;
        }

        if (accountOtherSelected && (
            fields.customer_account_other_number.length <= 0 ||
            fields.customer_account_other_placement.length <= 0
        ))
        {
            return false;
        }
    }

    if (fields.customer_withdrawal_reason_option.length <= 0)
    {
        return false;
    }

    if (fields.customer_withdrawal_reason_option === "Kapitalbehov" && fields.customer_withdrawal_reason_kapitalbehov.length <= 0)
    {
        return false;
    }
    else if (fields.customer_withdrawal_reason_option === "Annat" && fields.customer_withdrawal_reason.length <= 0)
    {
        return false;
    }

    let actionSelected = false;
    if (state.fields.selected_type.options[0].checked)
    {
        for (let i = 0; i < fields.radio_action.options.length; i++)
        {
            if (fields.radio_action.options[i].checked)
            {
                actionSelected = true;
            }
        }
    }
    else if (state.fields.selected_type.options[1].checked)
    {
        for (let i = 0; i < fields.radio_action_withdraw.options.length; i++)
        {
            if (fields.radio_action_withdraw.options[i].checked)
            {
                actionSelected = true;
            }
        }
    }

    if (!actionSelected)
    {
        return false;
    }

    if (state.fields.radio_action.options[1].checked && state.fields.move_all_account.length <= 0)
    {
        return false;
    }

    if (state.fields.radio_action_withdraw.options[0].checked && (
        state.fields.move_some_account.length <= 0 ||
        state.fields.move_some_amount.length <= 0 ||
        state.fields.move_some_amount <= 0
    ))
    {
        return false;
    }

    if (state.fields.radio_action_withdraw.options[1].checked && (
        state.fields.withdraw_some_amount.length <= 0 ||
        state.fields.withdraw_some_amount <= 0
    ))
    {
        return false;
    }

    if (!state.fields.has_withdrawal_fee.options[0].checked && !state.fields.has_withdrawal_fee.options[1].checked)
    {
        return false;
    }

    if (state.fields.has_withdrawal_fee.options[1].checked && (
        state.fields.withdrawal_fee.length <= 0 ||
        state.fields.withdrawal_fee < 0 ||
        state.fields.withdrawal_fee > 100
    ))
    {
        return false;
    }

    if (state.fields.meeting_notes.length < 220 || state.fields.meeting_notes.length > 700)
    {
        return false;
    }

    if (state.fields.meeting_date.length <= 0)
    {
        return false;
    }

    if (state.fields.customer_experience.length < 220 || state.fields.customer_experience.length > 700)
    {
        return false;
    }

    let meetingFormChecked = false;
    for (let i = 0; i < fields.radio_meeting_form.options.length; i++)
    {
        if (fields.radio_meeting_form.options[i].checked)
        {
            meetingFormChecked = true;
        }
    }

    if (!meetingFormChecked)
    {
        return false;
    }

    return true;
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Fair/Withdrawal/Withdrawal.fulfillment.js